import React, {useState} from 'react';
import {AlertTriangle} from "lucide-react";
import {Button, Modal, Input} from "antd";
import ApiHandleSuccessMessage, {ApiHandleErrorMessage} from "@/lib/helper/apiHandleResultMessage";
import {URLS} from "@/lib/urls";
import {useApiStudentRemoveTakeLesson} from "@/api/lesson";
import {useNavigate, useParams} from "react-router-dom";
import {Link} from "react-router-dom";

function RemoveLesson({data}) {
    const navigate = useNavigate();
    const param = useParams();

    const [showWithdrawalModal, setShowWithdrawalModal] = useState(false);
    const {mutate: removeTakeLesson, isPending: isPendingRemove} = useApiStudentRemoveTakeLesson()

    function handleRemoveStudentLesson() {

        removeTakeLesson({id: param.id}, {
            onSuccess: (e) => {
                ApiHandleSuccessMessage(e)
                setShowWithdrawalModal(false)
                navigate(URLS.student.lessons.myLesson.list)
            },
            onError: (e) => {
                ApiHandleErrorMessage(e)
            }
        });
    }

    return (
        <>
            <Modal
                title="تایید انصراف"
                footer={[]}
                open={showWithdrawalModal}
                onCancel={() => setShowWithdrawalModal(false)}
            >
                <div className="mb-6">
                    <div
                        className="flex items-start gap-3 p-4 bg-red-50 border border-red-200 rounded-lg mb-4">
                        <AlertTriangle className="w-5 h-5 text-red-600 mt-0.5 flex-shrink-0"/>
                        <div>
                            <h4 className="font-medium text-red-900 mb-1">هشدار مهم</h4>
                            <p className="text-red-700 text-sm">
                                برای انصراف از کلاس توجه داشته باشید در صورتی که در بازه زمانی انتخاب
                                واحد یا حذف و اضافه باشید و از تاریخ شروع کلاس نگذشته باشد مبلغ پرداخت
                                شده به حساب شما باز خواهد گشت و در غیر این صورت این مبلغ به حساب شما
                                برگشت داده نخواهد شد
                                آیا از انصراف خود اطمینان دارید؟
                            </p>
                        </div>
                    </div>

                    <Input.TextArea
                        placeholder="دلیل انصراف را بنویسید (اختیاری)"
                        className="w-full p-3 border border-gray-300 rounded-lg resize-none h-24 text-sm"
                    ></Input.TextArea>
                </div>
                <div className="flex gap-3">
                    <Button

                        onClick={() => setShowWithdrawalModal(false)}
                        className="flex-1 px-4 py-2 border border-gray-300  rounded-lg hover:bg-gray-50 transition-colors"
                    >
                        انصراف
                    </Button>
                    <Button
                        loading={isPendingRemove}
                        onClick={() => handleRemoveStudentLesson()}
                        className="flex-1 px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors">
                        تأیید انصراف
                    </Button>
                </div>
            </Modal>


            <div className=" rounded-2xl shadow-lg p-6 border border-gray-100 dark:border-gray-600">
                <div className="flex items-center gap-3 mb-4">
                    <div className="p-2 bg-yellow-100 rounded-lg">
                        <AlertTriangle className="w-6 h-6 text-yellow-600"/>
                    </div>
                    <h3 className="text-lg font-semibold ">جابجایی به کلاس دیگر</h3>
                </div>

                <p className=" text-sm mb-4">
                    در صورت امکان می‌توانید کلاس خود را تغییر دهید
                </p>
                <Link to={URLS.student.lessons.take +
                    '?topic_id=' + data?.data?.data?.lesson?.topic_id +
                    '&grade_id=' + data?.data?.data?.lesson?.topic?.grade_id}>


                    <button

                        className="w-full px-4 py-2 bg-yellow-50 dark:bg-yellow-950/30 text-yellow-700 dark:text-yellow-300 border border-yellow-200 dark:border-yellow-800 rounded-lg hover:bg-yellow-100 dark:hover:bg-yellow-900/40 transition-colors"
                    >
                        لیست کلاس‌های قابل جابجایی
                    </button>
                </Link>
            </div>


            <div className="rounded-2xl shadow-lg p-6 border border-gray-100 dark:border-gray-600">
                <div className="flex items-center gap-3 mb-4">
                    <div className="p-2 bg-red-100 rounded-lg">
                        <AlertTriangle className="w-6 h-6 text-red-600"/>
                    </div>
                    <h3 className="text-lg font-semibold ">انصراف از کلاس</h3>
                </div>

                <p className=" text-sm mb-4">
                    برای انصراف از کلاس کلیک کنید
                </p>

                <button
                    onClick={() => setShowWithdrawalModal(true)}
                    className="w-full px-4 py-2 bg-red-50 dark:bg-red-950/30 text-red-700 dark:text-red-300 border border-red-200 dark:border-red-800 rounded-lg hover:bg-red-100 dark:hover:bg-red-900/40 transition-colors"
                >
                    درخواست انصراف
                </button>
            </div>

        </>
    );
}

export default RemoveLesson;